import './../css/ProductList.css';

import CrmProductListItem from './CrmProductListItem.js';

import {useState, useEffect} from "react";
import ProductService from "../Api/ProductService";

import {useDispatch, useSelector} from "react-redux";
import {getProductsAction} from "../store/actions/productActions";

import {Row, Col} from 'antd';

/*
import axios from "axios";
axios.post('http://crm.gard/api/products')
.then((response) => {
    let asd = response.data.data;
    console.log(asd)
});
*/


/*

async function getDf()
{
    try {
        const response = await axios.post('http://crm.gard/api/products');
        return response.data.data;
    } catch (err) {
        return null;
    }
}


//самовизивающа функція
(async function () {
    const productsData = await getDf();
    //console.log('1---', productsData);

    let productsElements = productsData.map(asd     => <CrmProductListItem id={asd.id} />);
    //console.log('2---', productsElements);

})();
*/



function CrmProductList() {

    const [products, setProducts] = useState();


    const dispatch = useDispatch();



    const filterData = useSelector(state => state.productFilterState);

    useEffect(() => {
        fetchProducts(filterData)
    }, [filterData])

    useEffect(() => {
        //dispatch(getProductsAction(filterData))
    }, [filterData])



    async function fetchProducts(filterData) {
        const response = await ProductService.getAll(filterData);
        //console.log(response);
        setProducts(response);
/*
        let productsElements = response.map(prod => <CrmProductListItem
            visible={modal}
            setVisible={setModal}
            key={ prod.id }
            prodItem={{
                id: prod.id,
                barcode: prod.barcode,
                name: prod.name,
                price: prod.price,
                quantity: prod.quantity,
                quantity_pack: prod.quantity_pack,
                unit: prod.unit,
                created_at: prod.created_at,
            }}
        />);
        setProducts(productsElements);
*/
    }



    return (
        <div className="ProductList">
            <Row>
                <Col xs={{span: 24, offset: 0}}>
                     <CrmProductListItem data={products} />
                </Col>
            </Row>
        </div>
    );
}

export default CrmProductList;
